import {
  FREE_DELIVERY_FROM_PRICE,
  ZIPCODES_ENKHUIZEN,
  ZIPCODES_STEDE_BROEC,
  ZIPCODES_WEST_FRIESLAND,
} from "../constants/DeliveryConstants";

export const parseZipPrefix = (zip) => {
  if (!zip) return null;
  const match = String(zip).match(/\d{4}/);
  return match ? parseInt(match[0], 10) : null;
};

/**
 * Valt dit adres buiten West-Friesland?
 *
 * Deze vlag staat nog steeds op elke order (`landelijk`) en wordt door de `api`
 * en `fulfilment-cms` gelezen, dus de postcodelogica blijft ongewijzigd. Wat
 * vervallen is, is de INVLOED ervan binnen de webshop: sinds alles via SooCool
 * gaat bepaalt hij niet meer de verzendkosten, de bezorgdagen of de teksten in
 * de checkout.
 */
export const isLandelijk = (zip) => {
  const prefix = parseZipPrefix(zip);
  if (!prefix) return true; // treat unknown as landelijk until specified
  const localZips = new Set([
    ...ZIPCODES_ENKHUIZEN,
    ...ZIPCODES_STEDE_BROEC,
    ...ZIPCODES_WEST_FRIESLAND,
  ]);
  return !localZips.has(prefix);
};

/**
 * Wordt dit product diepvries bezorgd? Sinds SooCool: altijd.
 *
 * Er was een regionale uitzondering - binnen West-Friesland reed Het
 * Vleescentrum zelf met gekoelde wagens, dus daar ging alleen mee wat het
 * product zelf als `frozen` had staan. Dat eigen transport is gestopt en SooCool
 * houdt de hele order van A tot Z bevroren, dus de uitzondering bestaat niet
 * meer en het productveld zegt niets meer over de bezorging.
 *
 * `null` bij een onbekende postcode blijft: dan is er nog geen bezorgwijze
 * gekozen en horen er ook geen labels te staan.
 */
export const effectiveFrozenForZip = (productFrozen, zip) => {
  const prefix = parseZipPrefix(zip);
  if (!prefix) return null; // unknown yet => do not show tags
  return true;
};

/**
 * De gratis-bezorgdrempel. Een bedrag, voor elk adres en elk land.
 *
 * De postcode gaat er alleen nog in omdat de aanroepers hem doorgeven; hij doet
 * niets meer. Tot september 2026 waren het er drie: 50 voor Enkhuizen/Stede
 * Broec, 50 voor overig West-Friesland en 150 landelijk.
 */
export const getFreeDeliveryFromPrice = (zip) => {
  return FREE_DELIVERY_FROM_PRICE;
};
